<template>
    <portal to="modal" v-if="shouldShow && src">
        <ModalContent
            width="wide"
            height="max"
            :show-close-button="true"
            content-padding="none"
            @close="onClose"
            :title="title"
            :use-modal-overlay-defaults="false"
        >
            <PdfPreview :src="src" />
            <button-group class="floating-buttons" align="left" margin="none">
                <slot name="buttons"></slot>
                <k-button v-if="acceptText" @click="onAccept">{{ acceptText }}</k-button>
                <k-button size="secondary" variant="contour" @click="onCancel">Avbryt</k-button>
            </button-group>
        </ModalContent>
    </portal>
</template>

<script setup>
    import ModalContent from "@/components/generic/ModalContent.vue";
    import PdfPreview from "@/components/generic/preview/PdfPreview.vue";
    import { Portal } from "portal-vue";
    import { ref, toRefs, watch } from "vue";
    import KButton from "@/components/Button.vue";
    import ButtonGroup from "@/components/ButtonGroup.vue";

    const emit = defineEmits(["cancel", "accept"]);

    const props = defineProps({
        src: {
            type: String,
            required: true,
        },
        acceptText: {
            required: false,
            type: String,
        },
        title: {
            required: false,
            type: String,
            default: "Förhandsgranskning",
        },
    });

    const shouldShow = ref(true);
    const { src } = toRefs(props);

    function onClose() {
        shouldShow.value = false;
    }

    function onCancel() {
        onClose();
        emit("cancel");
    }

    function onAccept() {
        emit("accept");
    }

    watch([src], ([newSrc]) => {
        if (!newSrc) {
            shouldShow.value = false;

            return;
        }

        shouldShow.value = true;
    });
</script>

<style lang="scss" scoped>
    @import "@/style/variables";

    ::v-deep(.modal-content) {
        .floating-buttons {
            background-color: $background-button-group-pop-up;
            padding: 1rem;
            position: sticky;
            bottom: 0;
            z-index: 2;
        }
    }
</style>
